import { Box, Typography } from '@mui/material';
import StoreCardShell, { rapCoinHeaderGradient, StorePriceFooter } from './StoreCardShell';

export default function RapCoinCard({ card, onClick }) {
  return (
    <StoreCardShell
      headerGradient={rapCoinHeaderGradient}
      onClick={() => onClick(card)}
      footer={
        <StorePriceFooter
          price={card.price}
          originalPrice={card.originalPrice}
          showBuyPrefix={false}
        />
      }
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 1.8, md: '13px' },
          height: '70%',
        }}
      >
        <Box
          component="img"
          src={card.coinImage}
          alt={`${card.title} RapCoins`}
          sx={{
            width: { xs: card.coinImageWidth, md: card.coinImageWidth },
            height: { xs: card.coinImageHeight, md: card.coinImageHeight },
            objectFit: 'contain',
            flexShrink: 0,
          }}
        />
        <Box sx={{ mt: { xs: 0.35, md: 0.45 }, textAlign: 'center', width: '100%', px: 0.25 }}>
          <Typography
            sx={{
              color: '#ffd700',
              fontWeight: 700,
              fontSize: { xs: 32, md: 32 },
              lineHeight: '32px',
              letterSpacing: '0.8px',
            }}
          >
            {card.title}
          </Typography>
          <Typography
            sx={{
              color: '#fff',
              fontWeight: 400,
              fontSize: { xs: 10, md: 10 },
              lineHeight: '12px',
              letterSpacing: 0,
              width: 45,
              mx: 'auto',
            }}
          >
            {card.subtitle}
          </Typography>
        </Box>
      </Box>
    </StoreCardShell>
  );
}
